import { GroupType } from '@/types/api/group';

export const groupTypeLabels = {
  [GroupType.SchoolClass]: 'Skolklass',
  [GroupType.SportsTeam]: 'Idrottslag',
  [GroupType.Association]: 'Förening',
};

export const groupNameLabels = {
  [GroupType.SchoolClass]: 'Klassens beteckning',
  [GroupType.SportsTeam]: 'Lagets beteckning',
  [GroupType.Association]: 'Gruppens namn',
};

export const organizationNameLabels = {
  [GroupType.SchoolClass]: 'Skolans namn',
  [GroupType.SportsTeam]: 'Klubbens namn',
  [GroupType.Association]: 'Föreningens namn',
};
